import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import '../../css/components/Tags/Tag.css'
/* NOTE: this component was called 'Star Tag' for tags that could be 
     dynamically swapped from a user-defined list of objects, marked 
     with an asterisk.  It is used to implement 'geo tags', which 
     are user-defined geographic community areas. */
const closeCrossTagImage = require('../../images/close-cross-tag.svg');
class Tags extends Component {

    showToolTip = () => {
        const bounds = ReactDOM
            .findDOMNode(this.refs['tagCross'])
            .getBoundingClientRect();
        if(this.props.showToolTip != null) {
            this.props.showToolTip(bounds.x - 37, bounds.y + 18, "Replace Tag")
        }
    }
    
    getCoords = () => {
        var box = ReactDOM
            .findDOMNode(this.refs['refStarTag'])
            .getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        this.props.hideUnHidePopUp(left + 28, top - 150, "CloseTag", this.props.cardId)
    }

    handleSaveCardsPopUpForHome = () => {
        const box = ReactDOM
            .findDOMNode(this.refs['tagCross'])
            .getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        this.props.handleSaveCardsPopUp(left, top, this.props.cardId, "BeforeYouCanDoThatPopUp")
    }

    render() {
        const hideCrossButton = this.props.isHomeFeed === true || this.props.isFavorites === true;
        //const displayText = this.props.data.length > 16 ? this.props.data.substring(0,16) + "..." : this.props.data;
        return (
            <div className="tag starTag" ref='refStarTag'>
                <span className={hideCrossButton ? "tagSpan no-cross-button" : "tagSpan"} title={this.props.data} onClick={this.props.isHomeFeed === true ? this.handleSaveCardsPopUpForHome : this.getCoords}>{this.props.data}</span>
                {!hideCrossButton ? 
                    <div className="closeTag" onMouseOver={this.showToolTip} onMouseOut={this.props.hideToolTip} ref='tagCross'>
                        <a onClick={this.props.isHomeFeed === true ? this.handleSaveCardsPopUpForHome : this.getCoords}>
                            <span className="tagCross"><img src={closeCrossTagImage} width={7} height={7} /></span>
                        </a>
                    </div>
                : null}
            </div>
        )
    }
}
export default Tags



// WEBPACK FOOTER //
// ./src/components/Tags/Tag.js